import React, { useState, useEffect, useRef, useContext } from "react";
import { checkout, completeCheckout } from "./../../api";
import { useHistory } from "react-router-dom";
import CurrencyInput from "./../../components/CurrencyInput";
import UserContext from "./../../context/UserContext";
import { useAmbient } from '../../hooks/ambient';
import "./styles.scss";

function AddFunds({ checkoutMock }) {
  const checkoutWith = checkoutMock || doCheckout;
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const { isEnterpriseEnv } = useAmbient();
  const history = useHistory();

  const checkoutConfig = useRef({ onSuccess, onClose, onError });

  useScript("https://assets.pagar.me/checkout/checkout.js");

  const [amountValue, setAmountValue] = useState("");

  let valueInCents = useRef(0);

  const userData = useContext(UserContext);

  useEffect(() => {
    if (isEnterpriseEnv) history.push('/')
  }, [isEnterpriseEnv, history]);

  // onSuccess is called by the pagar.me modal
  // after the transaction is finished with success.
  // the authorization token is sent as argument
  function onSuccess({ token }) {
    const url = checkoutConfig.current.urlCallback;
    if (!url) {
      // V5 flow - user will be redirected to success page
      setAmountValue("");
      setIsLoading(false);
      return;
    }
    completeCheckout(url, token, valueInCents.current)
      .then(() => {
        userData.addToBalanceInCents(valueInCents.current); // adds to amount in NavBar
        setAmountValue("");
        setIsLoading(false);
        setSuccessMessage(true);
        setErrorMessage(false);
      })
      .catch(onError);
  }

  // onError is called by the pagar.me modal
  // if the transaction encounters an error
  function onError() {
    setAmountValue("");
    setErrorMessage(true);
    setIsLoading(false);
  }

  // onError is called by the pagar.me modal
  // if the user closes the modal
  function onClose() {
    setSuccessMessage(false);
    setErrorMessage(false);
    setIsLoading(false);
  }

  function checkoutHandler() {
    // Convert currency to cents
    // Examples:
    // "R$ 10,00" -> 1000
    // "R$ 10,50" -> 1050
    // "R$ 1.000,00" -> 100000
    // "R$ 1.500,75" -> 150075

    const hasDecimal = amountValue.indexOf(",") !== -1;

    if (hasDecimal) {
      // Has decimal: remove everything except digits
      // "R$ 10,50" -> "1050"
      // "R$ 1.000,75" -> "100075"
      valueInCents.current = amountValue.replace(/\D/g, "");
    } else {
      // No decimal: remove non-digits and add 00 for cents
      // "R$ 10" -> "10" -> "1000"
      // "R$ 1.000" -> "1000" -> "100000"
      valueInCents.current = amountValue.replace(/\D/g, "") + "00";
    }

    if (parseInt(valueInCents.current, 10) === 0 || !valueInCents.current) {
      return false;
    }

    console.log("Amount value:", amountValue);
    console.log("Value in cents:", valueInCents.current);

    checkoutWith(valueInCents.current);
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      checkoutHandler();
    }
  }

  async function doCheckout(amount) {
    setIsLoading(true);
    try {
      await checkout(amount, checkoutConfig.current);
    } catch (error) {
      // Error already handled by checkout function
      console.error("Checkout error:", error);
    }
  }
  return (
    <>
      <h1>Adicionar Fundos</h1>
      <div className="payment-form">
        <div className="tile is-ancestor">
          <div className="tile is-6 is-vertical">
            {successMessage ? (
              <div className="notification is-success">
                <button
                  className="delete"
                  onClick={() => setSuccessMessage(false)}
                ></button>
                Fundos adicionados com successo!
              </div>
            ) : (
              ""
            )}
            {errorMessage ? (
              <div className="notification is-danger">
                <button
                  className="delete"
                  onClick={() => setErrorMessage(false)}
                ></button>
                Erro ao adicionar fundos.
              </div>
            ) : (
              ""
            )}
            <p>Informe o valor para depósito:</p>
            <CurrencyInput
              aria-label="amount-input"
              size="12"
              maxLength="13"
              placeholder="R$ 0,00"
              type="numeric"
              value={amountValue}
              onChange={e => setAmountValue(e.target.value)}
              onKeyPress={handleKeyPress}
              autoFocus
            />
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              aria-label="checkout-button"
              onClick={checkoutHandler}
            >
              Próximo
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const useScript = url => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

export default AddFunds;
